import { render, staticRenderFns } from "./customizePlan.vue?vue&type=template&id=8c84cd70&scoped=true&"
import script from "./customizePlan.vue?vue&type=script&lang=js&"
export * from "./customizePlan.vue?vue&type=script&lang=js&"
import style0 from "./customizePlan.vue?vue&type=style&index=0&id=8c84cd70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c84cd70",
  null
  
)

export default component.exports